import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MailService } from '../../../../services/mail.service';
import { UserMinimal } from '../../../../models/user-minimal.model';
import { User } from '../../../../models/user.model';
import { TransportOrderView } from '../../../../models/transport-order-view.model';

@Component({
  selector: 'jhi-bary-mailto',
  templateUrl: './bary-mailto.component.html',
  styleUrls: ['./bary-mailto.component.scss'],
})
export class BaryMailtoComponent {
  @Input() isBtn: boolean = true;
  @Input() labelkey: string = 'validation-step.buttons.sendDocument';
  @Input() emailTransporter?: string | undefined;
  @Input() params?: {
    transportOrderView: TransportOrderView | undefined;
    transporterCompanyName: string | undefined;
    user: UserMinimal | undefined;
  };

  @Input() paramsDefaultSending?: {
    subject: string | undefined;
    userCompanyName: string | undefined;
    user: User | undefined;
  };

  @Input() type: LIST_MAILTO = LIST_MAILTO.ADD_DOCUMENT;

  @Output() changeEvent = new EventEmitter<boolean>();

  public subject: string = '';
  public body: string = '';

  constructor(protected translateService: TranslateService, public mailHelper: MailService) {}

  public loadEmail(): void {
    switch (this.type) {
      case LIST_MAILTO.ADD_DOCUMENT: {
        if (this.params?.transportOrderView) {
          this.subject = this.translateService.instant('mailto.add_document.subject', {
            transportOrderId: this.params?.transportOrderView?.id,
          }) as string;
          this.body = this.mailHelper.addDocumentBody(this.params.transportOrderView, this.params.transporterCompanyName, this.params.user);
        }
        break;
      }

      case LIST_MAILTO.ADD_DOCUMENT_DEFAULT_SENDING: {
        if (this.paramsDefaultSending?.subject) {
          this.subject = this.translateService.instant('mailto.defaultSending.add_document.subject') as string;
          this.body = this.translateService.instant('mailto.defaultSending.add_document.body') + '%0D%0A%0D%0A';
          this.changeEvent.emit(true);
        }
        break;
      }

      case LIST_MAILTO.ADD_DOCUMENT_ADR: {
        if (this.params?.transportOrderView) {
          this.subject = this.translateService.instant('mailto.add_document_adr.subject', {
            transportOrderId: this.params?.transportOrderView?.id,
          }) as string;
          this.body = this.mailHelper.addDocumentAdrBody(this.params.transportOrderView, this.params.transporterCompanyName, this.params.user!);
        }
        break;
      }
      default: {
        console.info("[INFO]: Le type de mail n'existe pas, le titre et le contenu est vide");
        break;
      }
    }
    window.top!.location.href = 'mailto:' + (this.emailTransporter ?? '') + '?subject=' + this.subject + '&body=' + this.body;
  }

  isDisplay(): boolean {
    if ([LIST_MAILTO.ADD_DOCUMENT, LIST_MAILTO.ADD_DOCUMENT_ADR].includes(this.type)) {
      return !!this.params?.transportOrderView;
    }
    if ([LIST_MAILTO.ADD_DOCUMENT_DEFAULT_SENDING].includes(this.type)) {
      return !!this.paramsDefaultSending?.subject;
    }
    return true;
  }
}

export enum LIST_MAILTO {
  ADD_DOCUMENT_DEFAULT_SENDING = 'ADD_DOCUMENT_DEFAULT_SENDING',
  ADD_DOCUMENT = 'ADD_DOCUMENT',
  ADD_DOCUMENT_ADR = 'ADD_DOCUMENT_ADR',
}
